import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { getPatronFiuuPaymentReturnUrl } from 'helpers/patronPaymentNavigation';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Fallback landing page when API cannot find an in-memory Fiuu session.
 * The browser still has the payment page URL in sessionStorage from before Fiuu.
 */
export const FiuuPaymentReturn = () => {
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		const storedPaymentUrl = getPatronFiuuPaymentReturnUrl();

		if (!storedPaymentUrl) {
			history.replace('/menu/patron-app/invalid-qr');
			return;
		}

		const redirectUrl = new URL(storedPaymentUrl);

		new URLSearchParams(location.search).forEach((value, key) => {
			redirectUrl.searchParams.set(key, value);
		});

		const pathWithSearch = `${redirectUrl.pathname}${redirectUrl.search}`;

		history.replace(pathWithSearch);
	}, [history, location.search]);

	return <Loading />;
};
